<template>
  <div class="headNav van-fade-enter-active">
    <div class="head">
      <div class="mainContent">
        <img
          @click="getActive('Inicio')"
          class="logo"
          src="@/assets/img/fodown_one_next.webp"
          alt=""
        />
        <div class="arrecredi_logo_ciew">
          <span style="color: #000000;">Arrecredi</span>
        </div>

        <!-- 移动端菜单开关 -->
        <div class="nav-toggle" @click.stop="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <ul class="nav" :class="{ 'nav--mobile-open': isMenuOpen }">
          <li :class="activeNav == 'Inicio' ? 'active' : ''">
            <a @click="getActive('Inicio')">Inicio</a>
            <div class="line"></div>
          </li>
          <li :class="activeNav == 'Aviso' ? 'active' : ''">
            <a @click="getActive('Aviso')">Centro de ayuda</a>
            <div class="line"></div>
          </li>
          <li :class="activeNav == 'loan' ? 'active' : ''">
            <a @click="getActive('loan')">Centro de informaciones</a>
            <div class="line"></div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import "./scss/nav.scss";

export default {
  name: "headNav",
  props: ["activeNav"],
  data() {
    return {
      isMenuOpen: false,
    };
  },
  created() {
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    getActive(val) {
      // this.activeNav = val;
      let url = "";
      switch (val) {
        case "Inicio":
          url = "/home?dialogVisible=1";
          break;
        case "sobre":
          url = "/about";
          break;
        case "Aviso":
          url = "/notice";
          break;
        case "loan":
          url = "/loan";
          break;
        case "ayuda":
          url = "/help";
          break;
      }
      this.isMenuOpen = false;
      this.$router.push(url);
    },
  },
};
</script>

<style>
</style>
